import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CALL_BOOKING_URLS } from "../../config/tripPlans";
import { WHATSAPP_URL } from "../WhatsAppFloatButton";

export function PlanContactActions({ planType }) {
  if (!CALL_BOOKING_URLS[planType]) return null;
  const callLabel = planType === "avec_moi" ? "Réserver mon appel de 45 min" : "Réserver mon appel de 20 min";
  return (
    <div className="flex flex-wrap gap-3 mb-6" data-testid="plan-contact-actions">
      <a
        href={CALL_BOOKING_URLS[planType]}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary inline-flex items-center gap-2 text-sm"
        data-testid="book-call-btn"
      >
        <Phone size={14} strokeWidth={1.5} /> {callLabel}
      </a>
      {planType === "avec_moi" && (
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm px-5 py-2.5 text-white transition-opacity hover:opacity-90"
          style={{ background: "#25D366", borderRadius: "2px", fontFamily: "'Lora', Georgia, serif" }}
          data-testid="whatsapp-contact-btn"
        >
          <MessageCircle size={14} strokeWidth={1.5} /> M'écrire sur WhatsApp
        </a>
      )}
    </div>
  );
}
